"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productEndpoint = void 0;

var _index = require("../../index");

var productEndpoint = function productEndpoint() {
  var REACT_APP_DATA_ENDPOINT = process.env.REACT_APP_DATA_ENDPOINT;

  if (REACT_APP_DATA_ENDPOINT === 'nz-helix' || window.location.host.includes('nz')) {
    return (0, _index.getApiBaseURL)('v2', 'nz-helix');
  } else if (REACT_APP_DATA_ENDPOINT === 'helix') {
    return (0, _index.getApiBaseURL)('v2', 'helix');
  } else if (REACT_APP_DATA_ENDPOINT === 'premium') {
    return (0, _index.getApiBaseURL)('v2', 'premium');
  }

  return 'undefined';
};

exports.productEndpoint = productEndpoint;